import _ from 'lodash';
import { useAsyncFn } from 'react-use';

import UpdateOrg2FAPolicy from './api';
import { useCommonActionFromDALV2 } from '@shares/actionFormDALV2';
import { TRequestUpdateOrg2FAPolicy, TResponseUpdateOrg2FAPolicy } from './type';
import { CommonNotificationSaveError, CommonNotificationUpdateSuccessfully } from '@shares/CommonNotification';

export type TUseUpdateOrg2FAPolicy = {
  isLoading: boolean;
  response?: TResponseUpdateOrg2FAPolicy;
  handleUpdateOrg2FAPolicy: (request: TRequestUpdateOrg2FAPolicy) => Promise<TResponseUpdateOrg2FAPolicy | undefined>;
};

const useUpdateOrg2FAPolicy = (): TUseUpdateOrg2FAPolicy => {
  const commonActionFromDALV2 = useCommonActionFromDALV2();

  const [state, doFetch] = useAsyncFn(async (request: TRequestUpdateOrg2FAPolicy) => {
    if (_.isEmpty(request)) return;

    try {
      const response: Promise<TResponseUpdateOrg2FAPolicy> = commonActionFromDALV2(UpdateOrg2FAPolicy, request);
      const result = await response;
      if (result?.success) {
        CommonNotificationUpdateSuccessfully();
      } else {
        CommonNotificationSaveError(result?.message || 'Something went wrong!');
      }
      return result;
    } catch (error) {
      CommonNotificationSaveError(_.get(error, 'message', 'Something went wrong!'));
      return;
    }
  }, []);

  return {
    response: state?.value,
    isLoading: state.loading,
    handleUpdateOrg2FAPolicy: doFetch,
  };
};

export default useUpdateOrg2FAPolicy;
